import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { nodeWidgetCustomizationActions } from '../../actions/nodeWidgetCustomization';
import WidgetCustomization, { FORM_NAME, } from '../../components/modals/widgetcustomization';
import { nodeWidgetCustomizationLoadPayload, } from '../../reducers/nodes/widgetCustomization';
/** Sorts an array of object based on an object key provided by a parameter */
function sortBy(key) {
    return (a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);
}
const localizations = [
    { value: 'en-US', label: 'English' },
    { value: 'fr-FR', label: 'French' },
    { value: 'es-ES', label: 'Spanish' },
    { value: 'de-DE', label: 'German' },
    { value: 'it-IT', label: 'Italian' },
    { value: 'pl-PL', label: 'Polish' },
    { value: 'pt-PT', label: 'Portuguese' },
    { value: 'da', label: 'Danish' },
    { value: 'nl', label: 'Dutch' },
    { value: 'sv', label: 'Swedish' },
    { value: 'no', label: 'Norwegian' },
    { value: 'fi', label: 'Finnish' },
    { value: 'lt-LT', label: 'Lithuanian' },
    { value: 'lv-LV', label: 'Latvian' },
    { value: 'et-EE', label: 'Estonian' },
    { value: 'ru-RU', label: 'Russian' },
    { value: 'hr-HR', label: 'Croatian' },
    { value: 'ro-RO', label: 'Romanian' },
    { value: 'hu-HU', label: 'Hungarian' },
    { value: 'el-GR', label: 'Greek' },
    { value: 'th-TH', label: 'Thai' },
    { value: 'vi-VN', label: 'Vietnamese' },
    { value: 'ko-KR', label: 'Korean' },
    { value: 'id-ID', label: 'Bahasa Indonesia' },
    { value: 'ms-MY', label: 'Bahasa Malay' },
    { value: 'cs-CZ', label: 'Czech' },
    { value: 'zh-CN', label: 'Chinese Mandarin' },
    { value: 'ar', label: 'Arabic' },
    { value: 'hi-IN', label: 'Hindi' },
    { value: 'ja-JP', label: 'Japanese' },
    { value: 'tr-TR', label: 'Turkish' },
    { value: 'is', label: 'Icelandic' },
];
const localizationOptions = localizations
    .concat()
    .sort(sortBy('label'));
const mobilePositionOptions = [
    { value: 'bottom_right', label: 'Bottom right' },
    { value: 'bottom_left', label: 'Bottom left' },
];
const desktopPositionOptions = [
    { value: 'bottom_right', label: 'Bottom right' },
    { value: 'bottom_left', label: 'Bottom left' },
    { value: 'right', label: 'Top right' },
    { value: 'left', label: 'Top left' },
];
const makeDefaultNode = (actionNode) => (Object.assign(Object.assign({}, actionNode), { badges: [], icon: 'i-widget-customize', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.WIDGET_CUSTOMIZATION, overlay: [], payload: {
        localizations: {
            'en-US': {
                minimized: {
                    html_text_online: 'Need help? **We are online**',
                    html_text_offline: 'Get in touch',
                },
            },
        },
        theme: {
            color: '#5e6776',
            color_darken: '#283044',
            color_lighten: '#8292b6',
            text_color: '#ffffff',
        },
        medium: {
            minimized_view: {
                position: 'bottom_right',
                view: 'sticky',
            },
            chatbox_view: {
                position: 'bottom_right',
            },
        },
        small: {
            minimized_view: {
                position: 'bottom_right',
            },
            chatbox_view: {
                position: 'bottom_right',
            },
        },
        nextNodeId: uuid(),
    }, text: 'Widget Customization' }));
const mapStateToProps = (state, ownProps) => {
    const selectedLocalizations = [];
    for (const localIndex in state.nodeWidgetCustomization.localizations) {
        const localOption = localizationOptions.find((local) => local.value === localIndex);
        if (localOption !== undefined) {
            selectedLocalizations.push(localOption);
        }
    }
    return {
        currentFormValues: getFormValues(FORM_NAME)(state),
        desktopPositionOptions,
        initialValues: state.nodeWidgetCustomization,
        localizationOptions,
        mobilePositionOptions,
        node: ownProps.node.nodeType === FlowNodeTypes.WIDGET_CUSTOMIZATION
            ? ownProps.node
            : makeDefaultNode(ownProps.node),
        payload: state.nodeWidgetCustomization,
        selectedLocalizations,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addLocalization: (payload) => dispatch(nodeWidgetCustomizationActions.nodeWidgetCustomizationAddLocalization(payload)),
        change: (form, field, value) => dispatch(change(form, field, value)),
        nodeWidgetCustomizationLoadPayload: (payload) => dispatch(nodeWidgetCustomizationLoadPayload(payload)),
        removeLocalization: (payload) => dispatch(nodeWidgetCustomizationActions.nodeWidgetCustomizationRemoveLocalization(payload)),
        resetLocalization: () => dispatch(nodeWidgetCustomizationActions.nodeWidgetCustomizationResetLocalization()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WidgetCustomization);
